export const PUBLIC_API = [
    'Login',
];
